import gql from 'graphql-tag';
import promotionFragment from './promotion';
import entityInterfaceFragment from './entity-interface';

const name = 'claimedPromotion';
const fragment = gql`
  fragment ${name} on ClaimedPromotion {
    confirmationNumber
    claimedAt
    id
    redemption {
      code {
        type
        value
      }
      methods {
        description
        type
        value
      }
    }
    promotion {
      ...${promotionFragment.name}
    }
    claimedFor {
      ...${entityInterfaceFragment.name}
    }
  }
  
 ${promotionFragment.fragment}
 ${entityInterfaceFragment.fragment}
`;

export default {
  name,
  fragment,
};
